<div class="patient-wrapper">
  <msd-avatar [text]="initials" [src]="pictureUrl"></msd-avatar>
  <div class="name-wrapper">
    <span>{{name}}</span>
    <label *ngIf="archived">Archivé</label>
  </div>
</div>
<input *ngIf="checkable" class="form-check-input" type="checkbox" (change)="checkChange.emit()" [checked]="checked">

